export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/paper/customer/noauth/query`,
          data
        });
      },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/noHouseAuth.js